export default __webpack_public_path__ + "static/media/quote-open-outline-white.08a87f29.svg";